import clsx from 'clsx'

import style from './CenterOnRobotButton.module.css'

const CenterOnRobotButton = ({ onClick }: { onClick: () => void }) => {
  return (
    <div className={style.root} onClick={onClick}>
      <button className={style.button}>
        <span className={clsx('mapboxgl-ctrl-icon', style.icon)} />
      </button>
    </div>
  )
}

export default CenterOnRobotButton
